import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  label: string;
  centered?: boolean;
}
export function CTAButton({
  label,
  centered = true
}: CTAButtonProps) {
  return <motion.div className={`py-12 md:py-16 bg-dark-900 ${centered ? 'flex justify-center' : ''}`} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} data-id="element-26">
      <motion.a href="https://www.construyetuarca.com/cart/46478917959841:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 bg-brand-light text-dark-900 font-medium text-lg rounded-full overflow-hidden transition-transform" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-27">
        <span className="relative z-10 flex items-center gap-2" data-id="element-28">
          {label}
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-29" />
        </span>
        <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity" data-id="element-30"></div>
      </motion.a>
    </motion.div>;
}